<template>
  <div class="cart-title">
    <h1 class="text-capitalize">{{ title }}</h1>
    <h3 class="text-capitalize">{{ text }}</h3>
  </div>
</template>
<script>
export default {
  props: ['title', 'text']
}
</script>